import { Route } from 'src/routes/Route'

export const PurchasedCampaignsRoute = Route({
  path: 'purchased-campaigns',
})

export type PurchasedCampaignsRoute = Route<typeof PurchasedCampaignsRoute>
